module.exports = __webpack_public_path__ + "static/media/b.54d2f872.png";